function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n, SessionSelectors } from 'invision-core';
import LocaleKeys from '../../../../locales/keys';
import { grantCoupon, searchGrantableCoupons, setCurrentGrantCouponsPage, setGrantCouponsNameFilter, setSelectedCoupon, setGrantedCouponsPageSizePreference } from '../../../../reducers/actions/customer.coupons.actions';
import { CurrentCustomerSelector, CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { CustomerCouponsErrorSelector, IsFetchingGrantableCouponsSelector, IsGrantingCouponSelector, GrantCouponsCurrentPageNumberSelector, GrantCouponsNameFilterSelector, GrantCouponsRecordCountSelector, GrantCouponsSelectedPageSizePreference, GrantCouponsShouldShowEmptyStateSelector, GrantCouponsShouldShowNoResultsSelector, GrantCouponsTableDataSelector, GrantCouponsTotalPageNumberSelector, LastGrantedCouponDetailsSelector, SelectedCouponAssociationCardsDataSelector, SelectedCouponSelector } from '../../../../reducers/selectors/customer.coupons.selectors';
import { GRANTED_COUPON_ROUTE } from '../customer.coupons.config';
var MAX_SLOTS_FOR_PAGER = 5;
var GrantCouponsController = /*#__PURE__*/function () {
  function GrantCouponsController($ngRedux, $timeout, $state) {
    _classCallCheck(this, GrantCouponsController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.$state = $state;
    this.CustomerLocaleKeys = LocaleKeys;
    this.searchTerm = undefined;
    this.grantCoupon = this.grantCoupon.bind(this);
    this.columnDefs = [{
      field: 'DateAdded',
      displayName: i18n.translate(LocaleKeys.COUPONS.DATE_ADDED),
      width: 120,
      cellFilter: 'date:"shortDate"'
    }, {
      field: 'Name',
      displayName: i18n.translate(LocaleKeys.NAME),
      cellTemplate: require('./cellTemplates/name.html')
    }, {
      field: 'Discount',
      displayName: i18n.translate(LocaleKeys.DISCOUNT)
    }];
  }
  return _createClass(GrantCouponsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.grantCouponPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.grantCouponPopupApi = api;
        }
      };

      //hook up the confirmation grant coupon api
      this.grantCouponSuccessPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.grantCouponSuccessPopupApi = api;
        }
      };
      this.prepareTableData = function (tableData) {
        return tableData.map(function (rowData) {
          return Object.assign({}, rowData, {
            clickHandler: function clickHandler() {
              _this.openGrantCouponPopup(rowData);
            }
          });
        });
      };
      this.mapStateToTarget = function (store) {
        return {
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentPageNumber: GrantCouponsCurrentPageNumberSelector(store),
          customerCouponError: CustomerCouponsErrorSelector(store),
          isFetchingGrantableCoupons: IsFetchingGrantableCouponsSelector(store),
          isGrantingCoupon: IsGrantingCouponSelector(store),
          lastGrantedCouponDetails: LastGrantedCouponDetailsSelector(store),
          maximumSlots: MAX_SLOTS_FOR_PAGER,
          nameFilter: GrantCouponsNameFilterSelector(store),
          numberOfPages: GrantCouponsTotalPageNumberSelector(store),
          recordCount: GrantCouponsRecordCountSelector(store),
          selectedCouponAssociationCardsData: SelectedCouponAssociationCardsDataSelector(store),
          selectedCoupon: SelectedCouponSelector(store),
          selectedPageSizePreference: GrantCouponsSelectedPageSizePreference(store),
          shouldShowEmptyState: GrantCouponsShouldShowEmptyStateSelector(store),
          shouldShowNoResults: GrantCouponsShouldShowNoResultsSelector(store),
          tableData: _this.prepareTableData(GrantCouponsTableDataSelector(store)),
          userPageSizePreference: SessionSelectors.PageSizePreferenceSelector(store)
        };
      };
      this.controllerActions = {
        grantCoupon: grantCoupon,
        searchGrantableCoupons: searchGrantableCoupons,
        setCurrentGrantCouponsPage: setCurrentGrantCouponsPage,
        setGrantCouponsNameFilter: setGrantCouponsNameFilter,
        setGrantedCouponsPageSizePreference: setGrantedCouponsPageSizePreference,
        setSelectedCoupon: setSelectedCoupon
      };
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, this.controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = 'index.customercare.customer.coupons.grantCoupons';
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this.actions.setGrantCouponsNameFilter('');
      this.actions.setCurrentGrantCouponsPage(1);
      this.searchGrantableCoupons();
    }
  }, {
    key: "clearSearchText",
    value: function clearSearchText() {
      this.searchTerm = undefined;
      this.actions.setGrantCouponsNameFilter('');
      this.actions.setCurrentGrantCouponsPage(1);
      this.searchGrantableCoupons();
    }
  }, {
    key: "closeGrantCouponPopup",
    value: function closeGrantCouponPopup() {
      this.showGrantCouponPopup = false;
      this.grantCouponPopupApi.close();
    }
  }, {
    key: "grantCoupon",
    value: function grantCoupon(actionData) {
      var _this2 = this;
      this.actions.grantCoupon(this.state.currentCustomerId, actionData).then(function () {
        _this2.closeGrantCouponPopup();
        _this2.openGrantCouponConfirmationPopup();
      });
    }
  }, {
    key: "openGrantCouponPopup",
    value: function openGrantCouponPopup(grantedCoupon) {
      this.actions.setSelectedCoupon(grantedCoupon.CouponData);
      this.showGrantCouponPopup = true;
      this.$timeout(this.grantCouponPopupApi.open);
    }
  }, {
    key: "openGrantCouponConfirmationPopup",
    value: function openGrantCouponConfirmationPopup() {
      this.grantCouponSuccessPopupApi.open();
    }
  }, {
    key: "handleCloseGrantCouponConfirmationPopup",
    value: function handleCloseGrantCouponConfirmationPopup() {
      this.grantCouponSuccessPopupApi.close();
      this.$state.go(GRANTED_COUPON_ROUTE, {
        subscriberId: this.state.currentCustomerId
      });
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      this.actions.setCurrentGrantCouponsPage(page);
      this.searchGrantableCoupons();
    }
  }, {
    key: "onSearchTermSubmitted",
    value: function onSearchTermSubmitted(searchTerm) {
      this.searchTerm = searchTerm;
      this.actions.setGrantCouponsNameFilter(searchTerm);
      this.onPageSelected(1);
    }
  }, {
    key: "searchGrantableCoupons",
    value: function searchGrantableCoupons() {
      if (!this.state.selectedPageSizePreference) {
        this.actions.setGrantedCouponsPageSizePreference(this.state.userPageSizePreference);
      }
      var filterData = {
        couponName: this.state.nameFilter,
        pageSize: this.state.selectedPageSizePreference,
        pageNumber: this.state.currentPageNumber
      };
      this.actions.searchGrantableCoupons(filterData);
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setGrantedCouponsPageSizePreference(pageSize);
      this.onPageSelected(1);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {},
  template: require('./grant.coupons.html'),
  controller: GrantCouponsController,
  controllerAs: 'GrantCouponsController'
};